import { logger } from 'monitor';

import { POST_SIGN_IN_REDIRECT_URL } from '../config';

export const redirectPostSignIn = () => {
  const nextParam = window.location.search.match(/next=([^&]+)/)?.[1];
  logger.log('nextParam :', { nextParam });

  if (nextParam) {
    window.open(window.location.origin + nextParam, '_self');

    return;
  }
  window.open(window.location.origin + POST_SIGN_IN_REDIRECT_URL, '_self');
};
